import * as type from '../types/new-list'

export const setFilterEmployeesFrom = payload => {
    return{
        type: type.SET_FILTER_EMPLOYEES_FROM,
        amount: payload
    }
}

export const resetFilterEmployeesFrom = payload => {
    return{
        type: type.RESET_FILTER_EMPLOYEES_FROM,
    }
}

export const setFilterEmployeesTo = payload => {
    return{
        type: type.SET_FILTER_EMPLOYEES_TO,
        amount: payload
    }
}

export const resetFilterEmployeesTo = payload => {
    return{
        type: type.RESET_FILTER_EMPLOYEES_TO,
    }
}

export const setFilterRegistrationFrom = payload => {
    return{
        type: type.SET_FILTER_REGISTRATION_FROM,
        date: payload
    }
}

export const resetFilterRegistrationFrom = () => {
    return{
        type: type.RESET_FILTER_REGISTRATION_FROM
    }
}

export const setFilterRegistrationTo = payload => {
    return{
        type: type.SET_FILTER_REGISTRATION_TO,
        date: payload
    }
}

export const resetFilterRegistrationTo = () => {
    return{
        type: type.RESET_FILTER_REGISTRATION_TO
    }
}

export const setFilterOrganizationType = payload => {
    return{
        type: type.SET_FILTER_ORGANIZATION_TYPE,
        selection: payload
    }
}

export const resetFilterOrganizationType = () => {
    return{
        type: type.RESET_FILTER_ORGANIZATION_TYPE
    }
}

export const setFilterUnderLiquidation = payload => {
    return{
        type: type.SET_FILTER_UNDER_LIQUIDATION,
        selection: payload
    }
}

export const resetFilterUnderLiquidation = () => {
    return{
        type: type.RESET_FILTER_UNDER_LIQUIDATION
    }
}

export const setFilterIsBankrupt = payload => {
    return{
        type: type.SET_FILTER_IS_BANKRUPT,
        selection: payload
    }
}

export const resetFilterIsBankrupt = () => {
    return{
        type: type.RESET_FILTER_IS_BANKRUPT
    }
}

export const setFilterIsVatRegistered = payload => {
    return{
        type: type.SET_FILTER_IS_VAT_REGISTERED,
        selection: payload
    }
}

export const resetFilterIsVatRegistered = () => {
    return{
        type: type.RESET_FILTER_IS_VAT_REGISTERED
    }
}

export const setFilterInBusinessRegister = payload => {
    return{
        type: type.SET_FILTER_IN_BUSINESS_REGISTER,
        selection: payload
    }
}

export const resetFilterInBusinessRegister = () => {
    return{
        type: type.RESET_FILTER_IN_BUSINESS_REGISTER
    }
}

export const setFilterInFoundationRegister = payload => {
    return{
        type: type.SET_FILTER_IN_FOUNDATION_REGISTER,
        selection: payload
    }
}

export const resetFilterInFoundationRegister = () => {
    return{
        type: type.RESET_FILTER_IN_FOUNDATION_REGISTER
    }
}

export const appendLocationFilter = payload => {
    return{
        type: type.APPEND_LOCATION_FILTER,
        selection: payload
    }
}

export const resetAppendLocationFilter = () => {
    return{
        type: type.RESET_APPEND_LOCATION_FILTER
    }
}

export const removeLocationFilter = payload => {
    return{
        type: type.REMOVE_LOCATION_FILTER,
        selection: payload
    }
}

export const resetRemoveLocationFilter = () => {
    return{
        type: type.RESET_REMOVE_LOCATION_FILTER
    }
}

export const requestApiListSize = payload => {
    return{
        type: type.REQUEST_LIST_SIZE,
        body: payload
    }
}

export const resetApiListSize = () => {
    return{
        type: type.RESET_LIST_SIZE
    }
}

export const appendIndustryCodesFilter = payload => {
    return{
        type: type.APPEND_INDUSTRY_CODE_FILTER,
        selection: payload
    }
}

export const resetIndustryCodesFilter = () => {
    return{
        type: type.RESET_APPEND_INDUSTRY_CODE_FILTER
    }
}

export const removeIndustryCodesFilter = payload => {
    return{
        type: type.REMOVE_INDUSTRY_CODE_FILTER,
        selection: payload
    }
}

export const resetRemoveIndustryCodesFilter = () => {
    return{
        type: type.RESET_REMOVE_INDUSTRY_CODE_FILTER
    }
}

export const requestAddNewList = payload => {
    return{
        type: type.REQUEST_ADD_NEW_LIST,
        details: payload
    }
}

export const resetAddNewList = () => {
    return{
        type: type.RESET_ADD_NEW_LIST
    }
}

export const resetNewApiLink = () => {
    return{
        type: type.RESET_API_URL
    }
}

export const setNewApiLink = payload => {
    return{
        type: type.SET_API_URL,
        url: payload
    }
}

export const resetListInput = () => {
    return{
        type: type.RESET_LIST_INPUT
    }
}